import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class UserFullAgeGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate() {
    if (this.auth.user && this.auth.user.ageUnder18 === true) {
      this.router.navigate(['/courses']);
      return false;
    } else {
      return true;
    }
  }
}
